import React from 'react'
import getChipLabelUtil from 'components/ProductCard/utils/get-chip-label'
import ProductCardDelivery from 'components/ProductCard/containers/Delivery'
import shouldHideFullSizeChipUtil from 'components/ProductCard/components/DeliveryAndSampleChip/utils'

/**
 * @param {Object} props
 * @param {boolean} props.isFullSize
 * @param {string} props.chipLabel
 * @param {string} props.isMini
 * @returns {JSX.Element}
 */
export default function ProductCardDeliveryAndSampleChip (props) {
  const chipLabel = getChipLabelUtil(props)

  const shouldHideFullSizeChip = shouldHideFullSizeChipUtil({
    isFullSize: props.isFullSize,
    chipLabel
  })

  const debugProps = {
    props,
    chipLabel,
    shouldHideFullSizeChip
  }
  logUtil('ProductCardDeliveryAndSampleChip').debug('debugProps=', debugProps)

  return (
    <div className='product-card-delivery-wrapper'>
      <ProductCardDelivery
        {...props}
      />
      {
        chipLabel.length > 1 &&
        !shouldHideFullSizeChip && (
          <div className='product-card-sample-chip'>
            <span>{chipLabel}</span>
          </div>
        )
      }
    </div>
  )
}
